import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Label,
  Icon,
  Dropdown,
  Link,
  ExternalLink,
  EventLink,
  LargeLink,
  LargeExternalLink,
  AvatarContainer,
  AvatarWrapper,
  StyledAvatar,
  ImageContainer,
  LinkIcon,
  LinkTitle,
  LinkSub
} from './styled';

const IconLink = ({ item, variant, children }) => {
  if (item.externalUrl) {
    return (
      <LargeExternalLink href={item.externalUrl} variant={variant}>
        {children}
      </LargeExternalLink>
    );
  }
  return (
    <LargeLink exact to={item.url} variant={variant}>
      {children}
    </LargeLink>
  );
};

IconLink.propTypes = {
  item: PropTypes.shape({
    externalUrl: PropTypes.string,
    url: PropTypes.string,
    alignIconToTop: PropTypes.bool,
    color: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    imgWidth: PropTypes.number
  }),
  variant: PropTypes.string,
  children: PropTypes.node
};

const MenuItems = ({ items, variant, size }) => {
  if (size === 'large') {
    return items.map((item, i) => (
      <IconLink key={i} item={item} variant={variant}>
        <ImageContainer>
          <LinkIcon
            src={item.img}
            alt={`${item.label} icon`}
            imageWidth={item.imgWidth}
          />
        </ImageContainer>
        <div>
          <LinkTitle $color={item.color}>{item.label}</LinkTitle>
          <LinkSub>{item.sub}</LinkSub>
        </div>
      </IconLink>
    ));
  }

  return items.map((item, i) => {
    if (item?.hidden) {
      return null;
    }

    if (item.onClick) {
      return (
        <EventLink
          onClick={item.onClick}
          color={item.color}
          hoverColor={item.hoverColor}
          key={i}
          variant={variant}
        >
          {item.icon && <img alt={item.label} src={item.icon} />}
          {item.label}
        </EventLink>
      );
    }

    if (item.externalUrl) {
      return (
        <ExternalLink href={item.externalUrl} key={i} variant={variant}>
          {item.icon && <img alt={item.label} src={item.icon} />}
          {item.label}
        </ExternalLink>
      );
    }

    return (
      <Link to={item.url} exact key={i} variant={variant}>
        {item.icon && <img alt={item.label} src={item.icon} />}
        {item.label}
      </Link>
    );
  });
};

const Menu = ({
  label,
  labelColor,
  disabled,
  items,
  variant,
  size,
  position,
  className,
  avatar,
  gender
}) => {
  return (
    <Container disabled={disabled} className={className} size={size}>
      <Label variant={variant} labelColor={labelColor}>
        {gender && (
          <AvatarContainer src={!avatar ? gender : null} background={avatar?.background}>
            {avatar && (
              <AvatarWrapper>
                <StyledAvatar config={avatar} />
              </AvatarWrapper>
            )}
          </AvatarContainer>
        )}{' '}
        {label} <Icon />
      </Label>
      <Dropdown variant={variant} size={size} position={position}>
        <MenuItems items={items} variant={variant} size={size} />
      </Dropdown>
    </Container>
  );
};

Menu.propTypes = {
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  items: PropTypes.array.isRequired,
  variant: PropTypes.oneOf(['light', 'dark']),
  size: PropTypes.oneOf(['normal', 'large']),
  position: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  avatar: PropTypes.object,
  gender: PropTypes.string
};

Menu.defaultProps = {
  variant: 'light',
  size: 'normal',
  position: 'right',
  disabled: false
};

export default Menu;
